import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';
import {
	DELETE_MARKET_STATE_EXPORT_REPORT_EXECUTION_MUTATION,
	FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_DELIVERY_SCHEDULES_QUERY,
	FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_REPORT_EXECUTION_QUERY,
	FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_REPORT_EXECUTIONS_QUERY,
	SAVE_MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_MUTATION,
	SAVE_MARKET_STATE_EXPORT_REPORT_MUTATION,
} from '@app/model/market_state/_export/service/MarketStateExportGraphQLQueries';
import MarketStateExportReportInput from '@app/model/market_state/_export/input/MarketStateExportReportInput';
import MarketStateExportReportExecution from '@app/model/market_state/_export/MarketStateExportReportExecution';
import Return from '@app/model/_common/Return';
import MarketStateExportDeliveryScheduleInput
	from '@app/model/market_state/_export/delivery/input/MarketStateExportDeliveryScheduleInput';
import MarketStateExportDeliverySchedule from '@app/model/market_state/_export/delivery/MarketStateExportDeliverySchedule';

class MarketStateExportService {
	public static saveMarketStateExportReport = (input: MarketStateExportReportInput): Promise<MarketStateExportReportExecution> => {
		return GraphQLExecutor.execute<MarketStateExportReportExecution>(SAVE_MARKET_STATE_EXPORT_REPORT_MUTATION, { input });
	};

	public static findCompanyHotelMarketStateExportReportExecution = (
		companyHotelId: number,
		reportExecutionId: number,
	): Promise<MarketStateExportReportExecution> => {
		return GraphQLExecutor.execute<MarketStateExportReportExecution>(
			FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_REPORT_EXECUTION_QUERY,
			{ companyHotelId, reportExecutionId },
		);
	};

	public static findCompanyHotelMarketStateExportReportExecutions = (
		companyHotelId: number,
	): Promise<MarketStateExportReportExecution[]> => {
		return GraphQLExecutor.execute<MarketStateExportReportExecution[]>(
			FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_REPORT_EXECUTIONS_QUERY,
			{ companyHotelId },
		);
	};

	public static findCompanyHotelMarketStateExportDeliverySchedules = (
		companyHotelId: number,
	): Promise<MarketStateExportDeliverySchedule[]> => {
		return GraphQLExecutor.execute<MarketStateExportDeliverySchedule[]>(
			FIND_COMPANY_HOTEL_MARKET_STATE_EXPORT_DELIVERY_SCHEDULES_QUERY,
			{ companyHotelId },
		);
	};

	public static saveMarketStateExportDeliverySchedule = (
		input: MarketStateExportDeliveryScheduleInput,
	): Promise<MarketStateExportDeliverySchedule> => {
		return GraphQLExecutor.execute<MarketStateExportDeliverySchedule>(
			SAVE_MARKET_STATE_EXPORT_DELIVERY_SCHEDULE_MUTATION,
			{ input },
		);
	};

	public static deleteMarketStateExportReportExecution = (reportExecutionId: number): Promise<Return> => {
		return GraphQLExecutor.execute<Return>(DELETE_MARKET_STATE_EXPORT_REPORT_EXECUTION_MUTATION, { reportExecutionId });
	};
}

export default MarketStateExportService;
